module.exports = __webpack_public_path__ + "static/9-f98f59dd085c712f5cb7e7ecfda64e83.jpg";